__webpack_require__.p = "https://dev.parcelhub.ae/monitoring/control-tower/";